<div class="file-drop-area">
  <span class="fake-btn" mat-icon-button> <mat-icon>cloud_upload</mat-icon> Choose file</span>
  <span class="file-msg">{{file ? file.name : 'or drag and drop file here' }}</span>
  <input class="file-input" type="file">
</div>
<app-progress [progress]="progress"></app-progress>